import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';
import { func, shape, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Button, Icon } from '@fiverr-private/fit';
import { r_magic } from '@fiverr-private/icons';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import useImpressionObserver from '../../../hooks/useImpressionObserver';
import { bigQuery } from '../bi';
import { SWITCHER_STATES } from '../constants';
import services from './icons/services';
import classes from './index.module.scss';
import { useTracking } from './hooks/useTracking';

const { reportForkingPointView, reportForkingPointClick } =
    marketplaceIntegration;

/**
 * Renders a toggle between Logo Services SC and Logo Maker.
 */
const Toggle = ({
    onChange = noop,
    activeState = SWITCHER_STATES.LOGO_SERVICES,
    classNames,
    biProps: { listingsType, searchQuery } = {},
}) => {
    const [activeButton, setActiveButton] = useState(activeState);

    useTracking({ listingsType, searchQuery });

    useEffect(() => {
        setActiveButton(activeState);
    }, [activeState]);

    useImpressionObserver(`.${classes.toggleWrapper}`, () => {
        reportForkingPointView();
        bigQuery.trackForkIsShown();
    });

    const handleButtonClick = (tabType) => (event) => {
        event.stopPropagation();
        setActiveButton(tabType);
        onChange(tabType);
        reportForkingPointClick(tabType);
        bigQuery.trackForkIsClicked(tabType);
    };

    return (
        <div className={classnames(classes.toggleWrapper, classNames)}>
            <div
                className={classnames(classes.toggleGroup, {
                    [classes.active]:
                        activeButton === SWITCHER_STATES.LOGO_MAKER,
                })}
            >
                <Button
                    onClick={handleButtonClick(SWITCHER_STATES.LOGO_SERVICES)}
                    className={classnames(classes.toggle, {
                        [classes.active]:
                            activeButton === SWITCHER_STATES.LOGO_SERVICES,
                    })}
                >
                    <Icon size={24}>{services}</Icon>
                    <div className={classes.content}>
                        <span className={classes.contentTitle}>
                            <I18n
                                k={`variations_display.marketplace_listing.toggle.${SWITCHER_STATES.LOGO_SERVICES}.label`}
                            />
                        </span>
                        <br />
                        <span className={classes.contentDescription}>
                            <I18n
                                k={`variations_display.marketplace_listing.toggle.${SWITCHER_STATES.LOGO_SERVICES}.description`}
                            />
                        </span>
                    </div>
                </Button>
                <Button
                    onClick={handleButtonClick(SWITCHER_STATES.LOGO_MAKER)}
                    className={classnames(classes.toggle, {
                        [classes.active]:
                            activeButton === SWITCHER_STATES.LOGO_MAKER,
                    })}
                >
                    <Icon size={24}>{r_magic}</Icon>
                    <div className={classes.content}>
                        <span className={classes.contentTitle}>
                            <I18n
                                k={`variations_display.marketplace_listing.toggle.${SWITCHER_STATES.LOGO_MAKER}.label`}
                            />
                        </span>
                        <br />
                        <span className={classes.contentDescription}>
                            <I18n
                                k={`variations_display.marketplace_listing.toggle.${SWITCHER_STATES.LOGO_MAKER}.description`}
                            />
                        </span>
                    </div>
                </Button>
            </div>
        </div>
    );
};

Toggle.propTypes = {
    onChange: func,
    classNames: string,
    activeState: string,
    biProps: shape({
        listingsType: string,
        searchQuery: string,
    }),
};

export default Toggle;
